// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.button[data-v-41796a82] {\n  border-radius: $border-radius;\n  height: 50px;\n}\n.secondary-button[data-v-41796a82] {\n  color: $color-secondary;\n  font-size: 16px;\n  font-weight: 500;\n  letter-spacing: 0;\n}\n", ""]);
// Exports
module.exports = exports;
